import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = ['#2C5F34', '#FF0000', '#FFCE1B']; 
// Approved, Rejected, Pending

const MeetingStatusAnalytics = ({
  meetingStatusAnalytics,
}: {
  meetingStatusAnalytics: any[];
}) => {

  // 🔹 Filter only required statuses
  const filtered = meetingStatusAnalytics.filter((item:any) =>
    ['Approved', 'Rejected', 'Pending'].includes(item.title)
  );

  const total = filtered.reduce(
    (sum, item) => sum + Number(item.value || 0),
    0
  );

  const data = {
    labels: filtered.map((item:any) => item.title),
    datasets: [
      {
        data: filtered.map((item:any) => item.value),
        backgroundColor: COLORS,
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
      },
      tooltip: {
        enabled: true,
      },
    },
    cutout: '70%',
  };

  return (
    <div className="relative w-full max-w-[350px] h-[300px] mx-auto">
      <Pie data={data} options={options} />

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center pointer-events-none">
        <div className="text-2xl font-bold text-gray-800">
          {total}
        </div>
        <div className="text-xs font-semibold text-gray-500">
          Total
        </div>
      </div>
    </div>
  );
};

export default MeetingStatusAnalytics;
